import type {LayoutLocations, CellId, CellSpans} from '../types';
import type {BreakpointID} from '@packages/systems/style/types';
import {VariantStateKey} from '@packages/systems/style-legacy/selectors';
import isRowEditingLocked from './isRowEditingLocked';

/**
 * Computes whether a Cell spans across multiple rows or columns, and therefore
 * can be un-merged.
 */
const computeUnmergeCell = (
  cellId: CellId,
  locations: LayoutLocations,
  mediaQuery: BreakpointID,
  variantState: VariantStateKey | null
): {
  canUnmerge: boolean;
  spans: CellSpans;
} => {
  const location = locations[cellId];
  if (!location) {
    return {canUnmerge: false, spans: {rowSpan: 0, colSpan: 0}};
  }

  const colSpan = location.gridColumnEnd - location.gridColumnStart;
  const rowSpan = location.gridRowEnd - location.gridRowStart;

  if (isRowEditingLocked(mediaQuery, variantState)) {
    return {canUnmerge: false, spans: {rowSpan, colSpan}};
  }

  const canUnmerge = colSpan > 1 || rowSpan > 1;
  return {
    canUnmerge,
    spans: {rowSpan, colSpan},
  };
};

export default computeUnmergeCell;
